module.exports = __webpack_public_path__ + "static/media/books.b117a50f.webp";